import { DialogContent, useDialogController } from '@ff-it/ui';
import type { ReactElement } from 'react';
import { DialogForm } from 'components';

import { usePlanMeta, usePlanMutations, usePlanSettings, usePlanStrategy } from '../../state';
import { BudgetScopeField, FeeAffinityField } from 'modules/campaign/common/budgetFields';

function SettingsForm(): ReactElement {
  const strategy = usePlanStrategy();
  const Fields = strategy.settingsFormFields;

  return (
    <>
      <BudgetScopeField name="budget_scope" label="Budget scope" required />
      <FeeAffinityField name="budget_fee_affinity" label="Budget fee affinity" required />

      {Fields && <Fields />}
    </>
  );
}

export function SettingsDialog(): ReactElement {
  const settings = usePlanSettings();
  const { planning } = usePlanMeta();

  const { updateSettings } = usePlanMutations();

  const dialog = useDialogController();
  const close = () => dialog.setOpen(false);

  return (
    <DialogContent testId="plan-settings">
      <DialogForm
        disabled={!planning}
        onSubmit={close}
        onDismiss={close}
        title="Plan settings"
        initialValues={settings}
        submitHandler={updateSettings}
      >
        <SettingsForm />
      </DialogForm>
    </DialogContent>
  );
}
